var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2511_11924)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4557 16.4851L89.689 23.6247L97.4783 24.4935C97.9016 24.5408 98.2375 24.8146 98.3692 25.2197C98.5008 25.6247 98.3899 26.0437 98.0753 26.3308L92.2844 31.6122L93.8651 39.2889C93.951 39.7061 93.7944 40.1103 93.4497 40.3606C93.1052 40.6111 92.6723 40.635 92.302 40.4244L85.4896 36.5488L78.6772 40.4244C78.3069 40.635 77.8743 40.6108 77.5296 40.3606C77.1851 40.1103 77.0285 39.7061 77.1144 39.2889L78.6951 31.6124L72.9042 26.331C72.5896 26.0439 72.4787 25.6249 72.6103 25.2199C72.7419 24.8148 73.0779 24.541 73.5012 24.4937L81.2904 23.6249L84.5238 16.4853C84.6995 16.0973 85.0637 15.8623 85.4896 15.8623C85.9156 15.8621 86.28 16.0971 86.4557 16.4851Z",
    fill: "#FFD944"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4557 16.485L89.689 23.6247L97.4783 24.4935C97.9016 24.5408 98.2375 24.8146 98.3692 25.2196C98.5008 25.6247 98.3899 26.0437 98.0752 26.3307L92.2844 31.6122L93.8651 39.2889C93.951 39.7061 93.7944 40.1103 93.4497 40.3606C93.1052 40.611 92.6723 40.635 92.302 40.4243L85.4896 36.5487V15.8621C85.9156 15.8621 86.28 16.0971 86.4557 16.485Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9659 1.40175L56.9768 10.2584L66.6394 11.3362C67.0627 11.3835 67.3987 11.6573 67.5303 12.0624C67.662 12.4674 67.5511 12.8864 67.2364 13.1735L60.0527 19.725L62.0135 29.248C62.0994 29.6652 61.9428 30.0692 61.5983 30.3196C61.2536 30.5699 60.8209 30.5941 60.4506 30.3834L52 25.5759L43.5492 30.3834C43.1789 30.5941 42.746 30.5699 42.4015 30.3196C42.0568 30.0692 41.9002 29.665 41.9861 29.248L43.9471 19.725L36.7634 13.1735C36.4488 12.8864 36.3379 12.4674 36.4695 12.0624C36.6011 11.6573 36.9371 11.3835 37.3604 11.3362L47.023 10.2584L51.0339 1.40155C51.2097 1.01358 51.5739 0.778564 51.9998 0.778564C52.426 0.778768 52.7902 1.01358 52.9659 1.40175Z",
    fill: "#FFD944"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9659 1.40179L56.9768 10.2585L66.6394 11.3362C67.0627 11.3836 67.3987 11.6574 67.5303 12.0624C67.662 12.4674 67.551 12.8865 67.2364 13.1735L60.0527 19.7251L62.0135 29.248C62.0994 29.6652 61.9428 30.0692 61.5983 30.3197C61.2536 30.5699 60.8209 30.5941 60.4506 30.3835L52 25.5759V0.778809C52.426 0.778809 52.7902 1.01362 52.9659 1.40179Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.476 16.4851L22.7094 23.6247L30.4986 24.4935C30.9219 24.5408 31.2579 24.8146 31.3895 25.2197C31.5211 25.6247 31.4102 26.0437 31.0956 26.3308L25.3047 31.6122L26.8854 39.2889C26.9713 39.7061 26.8147 40.1103 26.47 40.3606C26.1255 40.6111 25.6927 40.635 25.3226 40.4244L18.5102 36.5488L11.6978 40.4244C11.3275 40.635 10.8948 40.6108 10.5501 40.3606C10.2056 40.1103 10.049 39.7061 10.1349 39.2889L11.7156 31.6124L5.92475 26.331C5.61011 26.0439 5.4992 25.6249 5.63082 25.2199C5.76245 24.8148 6.09842 24.541 6.52173 24.4937L14.311 23.6249L17.5443 16.4853C17.72 16.0973 18.0842 15.8623 18.5102 15.8623C18.9361 15.8621 19.3003 16.0971 19.476 16.4851Z",
    fill: "#FFD944"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.476 16.485L22.7094 23.6247L30.4986 24.4935C30.9219 24.5408 31.2579 24.8146 31.3895 25.2196C31.5211 25.6247 31.4102 26.0437 31.0956 26.3307L25.3047 31.6122L26.8854 39.2889C26.9713 39.7061 26.8147 40.1103 26.47 40.3606C26.1255 40.611 25.6927 40.635 25.3226 40.4243L18.5102 36.5487V15.8621C18.9361 15.8621 19.3003 16.0971 19.476 16.485Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5102 51.6211C23.1105 51.6211 26.8399 54.2428 26.8399 60.2888C26.8399 66.3351 23.1105 71.2365 18.5102 71.2365C13.9098 71.2365 10.1804 66.3349 10.1804 60.2888C10.1806 54.2428 13.91 51.6211 18.5102 51.6211Z",
    fill: "#F6DCCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5102 51.6211C23.1103 51.6211 26.8399 54.2428 26.8399 60.2888C26.8399 66.3351 23.1103 71.2365 18.5102 71.2365V51.6211Z",
    fill: "#F1CBBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12083 104.462H34.8997C36.0679 104.462 37.0205 103.509 37.0205 102.341V82.2269C37.0205 78.1061 33.3523 75.7689 29.1773 74.7332C22.1676 72.9938 15.0625 72.8764 7.84327 74.7332C3.67798 75.8045 0 78.1055 0 82.2269V102.341C0 103.509 0.952656 104.462 2.12083 104.462Z",
    fill: "#FFD944"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5102 104.461H34.8997C36.0679 104.461 37.0205 103.509 37.0205 102.341V82.2268C37.0205 78.106 33.3523 75.7688 29.1773 74.7331C25.6466 73.857 22.0919 73.3926 18.5104 73.3845L18.5102 104.461Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14635 104.462H9.53956V88.0722C9.53956 87.1352 8.77987 86.3755 7.84285 86.3755C6.90584 86.3755 6.14615 87.1352 6.14615 88.0722V104.462H6.14635Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4896 51.6211C90.09 51.6211 93.8194 54.2428 93.8194 60.2888C93.8194 66.3351 90.09 71.2365 85.4896 71.2365C80.8893 71.2365 77.1599 66.3349 77.1599 60.2888C77.1601 54.2428 80.8895 51.6211 85.4896 51.6211Z",
    fill: "#F6DCCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4896 51.6211C90.0898 51.6211 93.8194 54.2428 93.8194 60.2888C93.8194 66.3351 90.0898 71.2365 85.4896 71.2365V51.6211Z",
    fill: "#F1CBBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1003 104.462H101.879C103.047 104.462 104 103.509 104 102.341V82.2269C104 78.1061 100.332 75.7689 96.1567 74.7332C89.1471 72.9938 82.042 72.8764 74.8227 74.7332C70.6574 75.8045 66.9795 78.1055 66.9795 82.2269V102.341C66.9795 103.509 67.9323 104.462 69.1003 104.462Z",
    fill: "#FFD944"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4896 104.461H101.879C103.047 104.461 104 103.509 104 102.341V82.2268C104 78.106 100.332 75.7688 96.1565 74.7331C92.6258 73.857 89.0711 73.3926 85.4896 73.3845V104.461Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4602 104.462H97.8534V88.0722C97.8534 87.1352 97.0937 86.3755 96.1567 86.3755C95.2197 86.3755 94.4602 87.1352 94.4602 88.0722V104.462Z",
    fill: "#FAAB23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 39.5127C57.6544 39.5127 62.2385 42.7351 62.2385 50.1668C62.2385 57.5985 57.6544 63.6232 52 63.6232C46.3454 63.6232 41.7615 57.5985 41.7615 50.1668C41.7615 42.7353 46.3456 39.5127 52 39.5127Z",
    fill: "#F6DCCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 39.5127C57.6544 39.5127 62.2385 42.7351 62.2385 50.1668C62.2385 57.5985 57.6544 63.6232 52 63.6232V39.5127Z",
    fill: "#F1CBBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4293 104.462H71.5707C73.3229 104.462 74.7518 103.032 74.7518 101.28V77.1319C74.7518 72.0669 70.2431 69.1941 65.1113 67.921C56.4954 65.7831 47.7622 65.6386 38.8885 67.921C33.7687 69.2376 29.248 72.0659 29.248 77.1319V101.28C29.248 103.032 30.6772 104.462 32.4293 104.462Z",
    fill: "#FFD944"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 104.461H71.5707C73.3228 104.461 74.7518 103.032 74.7518 101.28V77.1318C74.7518 72.0669 70.2431 69.1941 65.1113 67.9209C60.7715 66.8441 56.4021 66.2733 52 66.2632V104.461Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3194 104.462H66.9037V84.3166C66.9037 83.3268 66.1014 82.5244 65.1115 82.5244C64.1217 82.5244 63.3194 83.3268 63.3194 84.3166V104.462Z",
    fill: "#FAAB23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0959 104.462H40.6803V84.3166C40.6803 83.3268 39.8779 82.5244 38.8881 82.5244C37.8985 82.5244 37.0959 83.3268 37.0959 84.3166V104.462Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2511_11924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(0 0.620117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipClients);
export default __webpack_public_path__ + "static/media/vip-clients.b00530714e2224a8eb559377f1669228.svg";
export { ForwardRef as ReactComponent };